// extracted by mini-css-extract-plugin
export default {"container":"_2CDsM","header":"SJRMt","link":"_3V338"};